import { render, staticRenderFns } from "./RichiestaTirocinantiFormativiCreate.vue?vue&type=template&id=bd698ff0&scoped=true&"
import script from "./RichiestaTirocinantiFormativiCreate.vue?vue&type=script&lang=ts&"
export * from "./RichiestaTirocinantiFormativiCreate.vue?vue&type=script&lang=ts&"
import style0 from "./RichiestaTirocinantiFormativiCreate.vue?vue&type=style&index=0&id=bd698ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd698ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCardText,VCol,VForm,VIcon,VRadio,VRadioGroup,VRow,VSelect,VTextField,VTextarea})
